import { useSearchParams } from "react-router-dom";
import { CatalogProducts } from "@/components/shop/CatalogProducts";
import { Seo } from "@/components/Seo";
export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const filter = params.get("jenis") ?? "";
  const lines: Record<string, string> = {
    meja: "desk",
    aksesori: "accessory",
    paket: "package",
  };
  return (
    <main className="mx-auto max-w-7xl px-5 pt-28 pb-20 sm:px-8">
      <Seo
        title="Katalog — Kanata Indonesia"
        description="Meja, aksesori, dan Paket Hemat Kanata. Pilih produk dan konfigurasi untuk ruang kerja Anda."
      />
      <h1 className="text-4xl font-medium tracking-tight">
        Bangun Ruang Kerja Ergonomis Impian Anda
      </h1>
      <p className="mt-4 text-ink/65">
        Pilih meja, aksesori, atau Paket Hemat dengan harga dan stok terkini.
      </p>
      <nav aria-label="Jenis produk" className="mt-8 flex gap-2 flex-wrap">
        {[
          ["", "Semua"],
          ["meja", "Meja"],
          ["aksesori", "Aksesori"],
          ["paket", "Paket Hemat"],
        ].map(([key, label]) => (
          <button
            key={key}
            aria-pressed={filter === key}
            className={`rounded-full border px-4 py-2 ${filter === key ? "bg-ink text-white" : "bg-white"}`}
            onClick={() => setParams(key ? { jenis: key } : {})}
          >
            {label}
          </button>
        ))}
      </nav>
      <CatalogProducts line={lines[filter]} />
    </main>
  );
}
